import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const GetDashboardStatsDocument = gql`
  query GetDashboardStats($newApprovalWorkflows: Boolean!, $newRequisitionApprovalWorkflows: Boolean!) {
    dashboardStats {
      invoicesAwaitingApprovalCount @skip(if: $newApprovalWorkflows)
      invoicesFlaggedCount
      purchaseOrdersNotSentCount
      transfersAwaitingApprovalCount
      workflowInvoicesAwaitingApprovalCount @include(if: $newApprovalWorkflows)
      workflowRequisitionsAwaitingApprovalCount @include(if: $newRequisitionApprovalWorkflows)
      requisitionsAwaitingApprovalCount @skip(if: $newRequisitionApprovalWorkflows)
      workflowCreditNotesAwaitingApprovalCount
      processDocumentsWithActionItemCount
    }
  }
` as unknown as DocumentNode<Types.GetDashboardStatsQuery, Types.GetDashboardStatsQueryVariables>
